"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("react"),u=(r,s=[])=>{const e=t.useRef(!0);t.useEffect(()=>{if(e.current){e.current=!1;return}r()},s)};exports.useDidUpdate=u;
